// MediaGalleryListItem
import React from 'react';
import PropTypes from 'prop-types';
import MediaGalleryImage from './MediaGalleryImage';
import MediaGalleryVideo from './MediaGalleryVideo';

const MediaGalleryListItem = props => (
  <li className={`gallery-item ${(props.item.type === 'Video') ? 'gallery-item--video' : 'gallery-item--image'}`}>
    {(props.item.type === 'Video')
      ? (
        <MediaGalleryVideo key={`video-${props.item.id}`} video={props.item} handleMediaClick={props.handleMediaClick} />
      ) : (
        <MediaGalleryImage key={`image-${props.item.id}`} image={props.item} handleMediaClick={props.handleMediaClick} />
      )
    }
  </li>
);

MediaGalleryListItem.propTypes = {
  handleMediaClick: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    columnSize: PropTypes.string.isRequired,
  }),
};

export default MediaGalleryListItem;
